import { omit } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import { TeamInsuranceProduct } from 'types';
import { SelectedTeamProductsMap } from './types';

export function useTeamProductsState(initialSelectedProducts?: SelectedTeamProductsMap) {
  const [selectedTeamProducts, setSelectedTeamProducts] = useState<SelectedTeamProductsMap | null>(null);

  // Initialize selected products if they are not set, the initialSelectedProducts can be sent on the next renders as it can wait for the insurance products to be loaded
  useEffect(() => {
    if (!selectedTeamProducts && initialSelectedProducts) {
      setSelectedTeamProducts(initialSelectedProducts);
    }
  }, [selectedTeamProducts, initialSelectedProducts]);

  const onProductSelected = useCallback((teamProduct: TeamInsuranceProduct) => {
    setSelectedTeamProducts((prev) => ({
      ...prev,
      [teamProduct.id]: {
        ...teamProduct,
      },
    }));
  }, []);

  const onProductRemoved = useCallback((productId: string) => {
    setSelectedTeamProducts((prev) => omit(prev, [productId]));
  }, []);

  return {
    selectedTeamProducts: selectedTeamProducts || ({} as SelectedTeamProductsMap),
    setSelectedTeamProducts,
    onProductSelected,
    onProductRemoved,
  };
}
